<div *ngIf="!custom; else content" class="card">
  <div class="card-body">
    <div class="tile-header mb-5 tile-header-hebrew">
      <span class="h3">{{ title }}</span>
      <a *ngIf="linkPath" class="link" [routerLink]="[linkPath]"
        ><p class="tile-heading">{{ linkText }}</p></a
      >
    </div>
    <div class="row tile-content">
      <div class="col-12">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>
    </div>
  </div>
</div>
<ng-template #content>
  <ng-content></ng-content>
</ng-template>
